import { BehaviorSubject } from 'rxjs'
import { RxJS } from './RxJS'
import { RxJSStateDefinable, UserPagePermissions } from '../Types/Types'

const appMenuSubject: BehaviorSubject<Definable<UserPagePermissions>> = new BehaviorSubject<
    Definable<UserPagePermissions>
>(undefined)

RxJS.userPagePermissions = RxJS.userPagePermissions ?? {
    subject: appMenuSubject,
    observable: appMenuSubject.asObservable(),
    announce: (userPagePermissions?: UserPagePermissions): void => {
        appMenuSubject.next(userPagePermissions)
    }
}

export const userPagePermissions$: RxJSStateDefinable<UserPagePermissions> = RxJS.userPagePermissions
